import { format, parseISO } from 'date-fns';

function deriveClockFromIso(iso?: string | null): string | null {
  if (!iso) return null;
  try {
    return format(parseISO(iso), 'HH:mm');
  } catch {
    return null;
  }
}

/**
 * GraphQL null means all-day. Do not treat null as "missing" and derive
 * HH:mm from UTC midnight — that becomes 17:00 in Pacific browsers and
 * then gets saved back as a timed job.
 */
export function explicitOrDerivedTime(
  explicit: string | null | undefined,
  iso?: string | null
): string | null {
  if (explicit === null) return null;
  if (explicit !== undefined) return explicit;
  return deriveClockFromIso(iso);
}

export function jobTimesCacheFields(job: {
  id: string;
  scheduleStart?: string | null;
  scheduleEnd?: string | null;
  scheduledStartDate?: string | null;
  scheduledStartTime?: string | null;
  scheduledEndDate?: string | null;
  scheduledEndTime?: string | null;
  scheduledStartStrict?: boolean;
  scheduledEndStrict?: boolean;
}) {
  return {
    id: job.id,
    scheduleStart: job.scheduleStart ?? null,
    scheduleEnd: job.scheduleEnd ?? null,
    scheduledStartDate:
      job.scheduledStartDate ??
      (job.scheduleStart ? job.scheduleStart.slice(0, 10) : null),
    scheduledStartTime: explicitOrDerivedTime(
      job.scheduledStartTime,
      job.scheduleStart
    ),
    scheduledEndDate:
      job.scheduledEndDate ??
      (job.scheduleEnd ? job.scheduleEnd.slice(0, 10) : null),
    scheduledEndTime: explicitOrDerivedTime(
      job.scheduledEndTime,
      job.scheduleEnd
    ),
    scheduledStartStrict: job.scheduledStartStrict ?? false,
    scheduledEndStrict: job.scheduledEndStrict ?? false,
  };
}
